import { map, find, isNil } from "lodash"
import { getInstrumentTypeCharacter } from "helpers/metrics/utils"
import { DELTA_SYMBOL } from "helpers/assets/constants"
import { RULES } from "connected-components/compare/position-sets"

export function handleGenerateHeaders(instrumentsWithMetadata, positionSetsMetadata, firstColumnLabel, isEndVsStartDateComparison) {
  if (instrumentsWithMetadata) {
    const isCompareWeightStrategy = instrumentsWithMetadata?.comparison?.type === RULES
    const matchedKeys = {}
    const instrumentNames = map(positionSetsMetadata, (positionSet) => {
      let instrumentType = null
      let instrument = find(instrumentsWithMetadata, ({ id, experimentId }, key) => {
        const isMatch = positionSet.experimentId ? experimentId === positionSet.experimentId : id === positionSet.id
        // In end vs start comparison, the comparison instrument is identical to the original instrument,
        // so matching only by id is not enough. We need to make sure we match with the original instrument once
        // and the comparison instrument once so the key/instrumentType is unique. To do this, we keep track of
        // the keys we've already matched and only match if the key hasn't been matched yet.
        if (isMatch && !matchedKeys[key]) {
          matchedKeys[key] = true
          instrumentType = key
          return true
        }
        return false
      })

      if (!instrument && positionSet.dates && instrumentsWithMetadata.rebalanced) {
        instrument = instrumentsWithMetadata.rebalanced
        instrumentType = "rebalanced"
      }

      if (isCompareWeightStrategy && instrumentType === "comparison") {
        return "Selection"
      }

      const instrumentTypeCharacter = getInstrumentTypeCharacter(instrumentType, isEndVsStartDateComparison, isCompareWeightStrategy, instrumentsWithMetadata[instrumentType]?.isOptimization)
      return instrumentTypeCharacter ? `${instrumentTypeCharacter}: ${instrument?.name}` : instrument?.name
    })
    const deltaHeader = isCompareWeightStrategy ? "Sizing" : DELTA_SYMBOL
    return [firstColumnLabel, ...instrumentNames, ...(instrumentNames.length > 1 ? [deltaHeader] : [])]
  }
  return [firstColumnLabel, ...map(positionSetsMetadata, "name")]
}

export function handleGenerateRows(rows, formatter) {
  return rows.map(({ label, values, formatter: itemFormatter }) =>
    [label, ...map(values, (value) => {
      if (isNil(value)) {
        return value
      }
      return (itemFormatter ?? formatter)(value)
    })],
  )
}
